import { render, staticRenderFns } from "./ChooseCourseBtn.vue?vue&type=template&id=5fc9142a&"
import script from "./ChooseCourseBtn.vue?vue&type=script&lang=js&"
export * from "./ChooseCourseBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports